import {ButtonOption} from 'common/components/popover-card/types';

export interface CohortDetail {
  /** The initial name of the cohort */
  name: string;

  /** The initial description of the cohort */
  description: string;

  /** The type of the cohort */
  type: string;

  /** The warning to be displayed in the modal */
  warning: string;
}

export enum VIEWS {
  CREATE_COHORT = `create-cohort`,
  BREAKDOWN = `breakdown`,
  POPOVER = `popover`,
}

export type ActionsPopoverState = {
  cohortModalIsOpen: boolean;
  cohortDetail: CohortDetail;
  dropMenuOpen: boolean;
  keydownProxyEl: HTMLElement;
  searchFilter: string;
  view: VIEWS;
};
export type ActionsPopoverAttrs = {
  open?: boolean;
  'is-segmented'?: boolean;
  title?: string;
  subtitle?: string;
  'button-options'?: ButtonOption[];
  'breakdown-options'?: TODO;
  event: string;
  'project-id': number;
  'workspace-id': number;
  'cohort-details': CohortDetail[];
  'cohort-names': string[];
  'prevent-close-selectors': string[];
};
